<template>
  <div class="Recall" :class="cls.display" style="z-index: 1002">
    <slot
      :adData="adData"
      :open="open"
      :close="close"
      :goAct="goAct"
      :statAction="statAction"
      :extend="statActions.extend"
    ></slot>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import envMgr from '../services/environment.manager';
import { localStorageService } from '../services/storage.service';
import util from '../utils/util';
import intendCarApi from '../apis/intendcar.api';
import { clientIdentityService } from '../services/intendedCar.service';
import { URLService } from '../services/url.service';
import * as queryValue from '../services/query.const';
import layManager from '../services/layer.manager';
let env = envMgr.getEnv();
export default {
  props: {
    defaultCls: { type: String, default: '' },
    displayCls: { type: String, default: '' },
    hideCls: { type: String, default: '' }
  },
  data () {
    return {
      adData: {
        title: '',
        subTitle: '',
        icon: '',
        landUrl: '',
        buttonText: '立即报名',
        activityType: 0,
        activityId: 0,
        recommendSeriesId: 0,
        extendField: {}
      },
      layerStatus: -1,
      statActions: {
        default: {
          goActActionName: 'arhall_default_send_click',
          closeActionName: 'arhall_default_close_click',
          showName: 'arhall_default_show'
        },
        promotion: {
          goActActionName: 'arhall_promotions_send_click',
          closeActionName: 'arhall_promotions_close_click',
          showName: 'arhall_promotions_show'
        },
        activity: {
          goActActionName: 'arhall_coupon_send_click',
          closeActionName: 'arhall_coupon_close_click',
          showName: 'arhall_coupon_show'
        },
        extend: {

        }
      },
      interceptCacheKey: '',
      isIntercept: false,
      pvTrackClick: 'ZNZT-vrdk-app_closed_click',
      pvTrackCancelClick: 'ZNZT-vrdk-app_closed_cancel_click',
      pvTrackShow: 'ZNZT-vrdk-app_closed_show',
    };
  },
  computed: {
    ...mapGetters({
      baseInfo: 'baseInfo',
      phoneCallStatus: 'phoneCall/phoneCallStatus',
    }),
    ...mapGetters('sales', { salesInfo: 'salesInfo', vrSalesInfo: 'vrSalesInfo' }),
    salesId () {
      return this.salesInfo.salesId;
    },
    extend () {
      return { channelId: this.vrSalesInfo.channelId };
    },
    dealerId () {
      return this.baseInfo.dealerId;
    },
    cls () {
      let cls = 'fn-hide';
      if (this.layerStatus === 0) {
        cls = this.hideCls;
      } else if (this.layerStatus === 1) {
        cls = this.displayCls;
      }
      return { display: this.defaultCls + ' ' + cls };
    },
    statAction () {
      let activityType = this.adData.activityType;
      if (activityType === 2 || activityType === 1) {
        return this.statActions.promotion;
      } else if (activityType === 3) {
        return this.statActions.activity;
      }
      return this.statActions.default;
    }
  },
  created () {
    let self = this;
    if (!util.browser.isApp) {
      return;
    }
    this.getBaseInfo().then(function () {
      return clientIdentityService.getClientId();
    }).then(function (result) {
      let dealerId = self.dealerId;
      return intendCarApi.getRecommendAd({ dealerId, advId: 10001, ...result });
    }).then(function (data) {
      if (!data || data.length === 0) {
        return;
      }
      let sessionId = util.getCookie('sessionid') || '';
      let key = `dealer_vr_recall_five_minutes_${sessionId}`;
      let isIntercept = self.validIsIntercept(key);
      // 从智效店铺过来或者从推荐的活动过来不拦截用户后退
      if (isIntercept) {
        self.adData = data[0];
        if (self.adData.extendField) {
          let extendData = self.adData.extendField || JSON.parse(self.adData.extendField);
          let activityType = self.adData.activityType = extendData.activityType;
          let activityId = self.adData.activityId = extendData.activityId;
          let recommendSeriesId = self.adData.recommendSeriesId = extendData.recommendSeriesId;
          self.statActions.extend.jp_dealer_id = self.adData.dealerId;
          self.statActions.extend.jp_activity_type = activityType;
          self.statActions.extend.jp_activity_id = activityId;
          self.statActions.extend.jp_recommend_series_id = recommendSeriesId;
          let dealerId = self.adData.dealerId;
          if (self.adData.activityType === 1 || self.adData.activityType === 2) {
            self.adData.landUrl = self.buildActivityUrl({
              dealerId: dealerId,
              activityType,
              activityId,
              recommendSeriesId
            });
          } else if (self.adData.activityType === 3) {
            let landUrl = new URLService(self.adData.landUrl);
            landUrl.queryParams.append('salesId', self.salesId)
              .append('dealerId', dealerId);
            self.adData.landUrl = landUrl.build();
          }
        }
      }
      self.interceptCacheKey = key;
      self.isIntercept = isIntercept;
    }).catch(function (ex) {
      console.error('获取用户离开拦截广告失败', ex);
    });
  },
  watch: {
    isIntercept: {
      handler () {
        this.handleJPIntercept();
      },
      immediate: true
    },
    phoneCallStatus: {
      handler () {
        this.handleCallIntercept();
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions({ 'getBaseInfo': 'getBaseInfo' }),
    /**
     * 处理竞品拦截
     */
    handleJPIntercept () {
      const self = this;
      if (self.isIntercept) {
        env.setIsIntercept(true);
        env.bindIntercept([self.jpInterceptCallBack.bind(self)]);
      } else {
        env.setIsIntercept(false);
      }
    },
    /**
     * 竞品拦截回调逻辑
     */
    jpInterceptCallBack () {
      const self = this;
      // 拦截回调时，如果在通话中先处理通话拦截，不处理竞品拦截
      if (self.phoneCallStatus === 1) {
        self.openCallInterceptConfirm();
      } else {
        let expiresDate = new Date().getTime() + 5 * 60 * 1000;
        localStorageService.setItem({ key: this.interceptCacheKey, value: true, expires: expiresDate });
        self.open();
      }
    },
    /**
     * 处理通话拦截
     */
    handleCallIntercept () {
      const self = this;
      // 如果没有竞品拦截绑定下通话拦截，有竞品拦截的话通话拦截在上面的竞品拦截回调中判断处理
      if (!self.isIntercept) {
        if (self.phoneCallStatus === 1) {
          env.setIsIntercept(true);
          env.bindIntercept([
            self.callInterceptCallBack.bind(self)
          ]);
        } else {
          env.setIsIntercept(false);
        }
      }
    },
    /**
     * 通话拦截回调逻辑
     */
    callInterceptCallBack () {
      this.openCallInterceptConfirm();
    },
    /**
     * 通话拦截确认提示弹窗
     */
    openCallInterceptConfirm () {
      const self = this;
      layManager.openConfirm({
        propsData: {
          showCloseIcon: true,
          title: '退出后将结束通话，确认吗？',
          okText: '是',
          cancelText: '否',
          pvTrackClick: this.pvTrackClick,
          okExtend: this.extend,
          pvTrackShow: this.pvTrackShow,
          pvTrackCancelClick: this.pvTrackCancelClick,
          cancelExtend: this.extend,
          onOk: function () {
            env.setIsIntercept(false);
            env.back();
          },
          onCancel: self.reBindIntercept.bind(self)
        }
      });
    },
    reBindIntercept () {
      this.handleJPIntercept();
      this.handleCallIntercept();
    },
    open () {
      let self = this;
      self.layerStatus = 1;
    },
    goAct () {
      env.setIsIntercept(false);
      window.location.replace(this.adData.landUrl);
    },
    close () {
      let self = this;
      self.layerStatus = 0;
      setTimeout(function () {
        self.layerStatus = -1;
      }, 100);
      env.setIsIntercept(false);
      env.back();
    },
    validIsIntercept (key) {
      let self = this;
      let val = localStorageService.getItem(key);
      var busi = self.$queryParams.busi;
      if (self.$queryParams.removeLeaveIntercept && val) {
        localStorageService.removeItem(key);
        val = localStorageService.getItem(key);
      }
      if (val || busi === queryValue.QUERY_BUSI_SMARTSTORE || busi === queryValue.QUERY_BUSI_SMARTADVERT) {
        return false;
      }
      return true;
    },
    buildActivityUrl ({ dealerId, activityType, activityId, recommendSeriesId }) {
      let opentype = 'promotion';
      if (activityType === 2) {
        opentype = 'promotionActivity';
      }
      if (!recommendSeriesId) {
        recommendSeriesId = 0;
      }
      return `/vr/${dealerId}/dealerm/index.html?busi=smartadvert&opentype=${opentype}&actid=${activityId}&recommendSeriesId=${recommendSeriesId}`;
    }
  }
};
</script>
